var panasonic_EUR7628010_TV = {
    name: "EUR7628010_TV",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,253,170,237,86,136],
        },
        {
            function: "KEY_INFO",
            name: "KEY_INFO",
            icon: "KEY_INFO",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,253,213,221,90,32],
        },
        {
            function: "ambiance",
            name: "ambiance",
            icon: "ambiance",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,253,235,189,104,128],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,254,235,221,104,128],
        },
        {
            function: "direct_tv_rec",
            name: "direct_tv_rec",
            icon: "direct_tv_rec",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,245,223,119,191,226],
        },
        {
            function: "KEY_ZOOM",
            name: "KEY_ZOOM",
            icon: "KEY_ZOOM",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,127,85,173,173,136],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,255,107,237,104,128],
        },
        {
            function: "NORMALISATION",
            name: "NORMALISATION",
            icon: "NORMALISATION",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,255,95,215,162],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,253,247,125,162],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,253,247,125,162],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,253,221,187,168,128],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,255,239,246,136],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,255,239,246,136],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,254,191,175,162],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,253,181,219,90,32],
        },
        {
            // function: "tv/av",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,253,191,111,162],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,255,213,250,168,128],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,253,234,222,170,32],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,254,234,238,170,32],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,253,117,107,170,136],
        },
        {
            function: "KEY_TEXT",
            name: "KEY_TEXT",
            icon: "KEY_TEXT",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,245,254,191,223,162],
        },
        {
            function: "favourite_page",
            name: "favourite_page",
            icon: "favourite_page",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,245,254,223,239,162],
        },
        {
            function: "index",
            name: "index",
            icon: "index",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,245,255,223,119,162],
        },
        {
            function: "hold",
            name: "hold",
            icon: "hold",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,245,254,239,247,162],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,255,223,238,136],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,253,239,123,162],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,254,239,187,162],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,253,119,174,232,128],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,255,111,219,162],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,253,183,182,232,128],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,254,183,214,232,128],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,253,91,213,186,32],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,255,175,235,162],
        },
        {
            function: "C",
            name: "C",
            icon: "C",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,254,213,237,90,32],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,253,215,186,232,128],
        },
        {
            function: "-/--",
            name: "-/--",
            icon: "-/--",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,247,253,106,235,86,136],
        },
    ]
}
export default panasonic_EUR7628010_TV